import { useEffect, useState } from 'react';
import { Box, Stack, Text, Divider, StackDivider, Button, Spinner } from '@chakra-ui/react';
import SettingsLayout from '@layouts/settings.layout';
import { useSetDocumentTitle, useStyledToast } from '@util/hooks';
import SectionHeader from '@components/meeting/section-header.component';
import { getStripeCustomerPortalSession } from '@services/query-services/lambda.query-service';
import { useUserStore } from '@store/app.store';
import { useNavigate } from 'react-router-dom';
import { usePeople } from '@services/query-services/people.query-service';

const BillingSettingsPage = () => {
  useSetDocumentTitle('Subscription - FORA');
  const [isLoading, setIsLoading] = useState(false);
  const user = useUserStore((state) => state.user);
  const tenant = useUserStore((state) => state.tenant);
  const isEnterpriseUser = useUserStore((state) => state?.isEnterpriseUser);
  const toast = useStyledToast();
  const navigate = useNavigate();
  const { data: peopleData } = usePeople(
    {
      active: true
    },
    { includeTotal: true }
  );

  useEffect(() => {
    if (user && toast && isEnterpriseUser()) {
      toast({
        title: 'No Access',
        description:
          'Your account is managed via enterprise contract. Please contact your administrator for billing inquiries.',
        status: 'error',
        duration: 5000,
        isClosable: true
      });
      navigate('/settings');
    }
  }, [user, isEnterpriseUser, toast, navigate]);

  const handleManageClick = async () => {
    setIsLoading(true);
    try {
      const session = await getStripeCustomerPortalSession(
        user.tenants[0].stripe_config.customer_id
      );
      window.location.href = session.url;
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <SettingsLayout>
      <Stack
        w={{ base: 'full', md: '2xl' }}
        gap={8}
        mt={8}
      >
        <Box>
          <Stack
            layerStyle='section-card'
            gap={0}
            divider={<StackDivider style={{ margin: 0 }} />}
          >
            <SectionHeader headline='Subscription Information' />
            <Stack
              gap={6}
              px={{ base: 4, lg: 11 }}
              py={{ base: 4, lg: 6 }}
            >
              <Box>
                <Text>
                  You have used {peopleData?.total} out of{' '}
                  {tenant?.internal_config?.num_of_licenses} licenses.
                </Text>
              </Box>
              <Box>
                <Text>
                  Last Payment Date:{' '}
                  {new Date(tenant?.stripe_config?.last_paid_at).toLocaleDateString()}
                </Text>
              </Box>
              <Divider />
              <Box>
                <Button
                  variant='reskinPrimary'
                  onClick={handleManageClick}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner size='sm' />
                      &nbsp;
                    </>
                  ) : (
                    ' '
                  )}
                  Manage Billing
                </Button>
              </Box>
            </Stack>
          </Stack>
        </Box>{' '}
      </Stack>
    </SettingsLayout>
  );
};

export default BillingSettingsPage;
